import { RouteConfig } from 'vue-router'
import Layout from '@/common/components/manage/layout.vue'
import SubLayout from '@/common/components/manage/components/AppMain.vue'
import RouterUtils from '@/common/utils/RouterUtils'

export function routerLogin(): RouteConfig {
  const item: RouteConfig = {
    path: '/login',
    name: 'login',
    meta: {
      code: '10',
      title: '登录',
      icon: 'ios-filing',
      hidden: true
    },
    component: () => import('@/views/login/login.vue')
  }
  return item
}

export function routerHome(): RouteConfig {
  const item11: RouteConfig = {
    path: '/',
    meta: {
      code: '11',
      title: '工作台',
      icon: 'app'
    },
    component: Layout
  }
  const item1101: RouteConfig = {
    path: '/',
    name: 'defaultHome',
    meta: {
      code: '1101',
      title: '工作台',
      icon: 'app',
      affix: true
    },
    component: () => import('@/views/home/home.vue')
  }


  RouterUtils.appendSubRoute(item11, item1101)
  // console.log(item11)
  return item11
}
export function router404(): RouteConfig {
  const item11: RouteConfig = {
    path: '/404',
    name: 'error_404',
    meta: {
      code: '12',
      icon: 'ios-filing',
      hidden: true
    },
    component: () => import('@/views/error-page/404.vue')
  }
  return item11
}
export function router401(): RouteConfig {
  const item11: RouteConfig = {
    path: '/401',
    name: 'error_401',
    meta: {
      code: '13',
      icon: 'ios-filing',
      hidden: true
    },
    component: () => import('@/views/error-page/401.vue')
  }
  return item11
}
export function router500(): RouteConfig {
  const item11: RouteConfig = {
    path: '*',
    name: 'error_500',
    meta: {
      code: '14',
      hidden: true
    },
    redirect: '/404'
  }
  return item11
}
